if ( typeof RecentlyViewed !== 'function' ) {

	class RecentlyViewed extends HTMLElement {

		connectedCallback() {

			const KEY = 'df_recently_viewed';
			const MAX_STORED = 12;

			const current = this.dataset.currentHandle;
			let stored = [];
			try { stored = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
			if ( ! Array.isArray(stored) ) stored = [];

			const others = stored.filter(h => h && h !== current);

			if ( current ) {
				try { localStorage.setItem(KEY, JSON.stringify([current, ...others].slice(0, MAX_STORED))); } catch (e) {}
			}

			const limit = parseInt(this.dataset.limit, 10) || 4;
			const handles = others.slice(0, limit);
			if ( ! handles.length ) return;

			const root = ( window.Shopify && Shopify.routes && Shopify.routes.root ) || '/';
			const grid = this.querySelector('[data-js-recently-viewed-grid]');
			const parser = new DOMParser();

			// A deleted/unpublished product 404s; it's skipped rather than
			// left as a gap, and the section stays hidden if none survive.
			Promise.all(handles.map(handle =>
				fetch(`${root}products/${encodeURIComponent(handle)}?section_id=${this.dataset.cardSection}`)
					.then(r => r.ok ? r.text() : '')
					.catch(() => '')
			)).then(parts => {
				let added = 0;
				parts.forEach(html => {
					if ( ! html ) return;
					const card = parser.parseFromString(html, 'text/html').querySelector('[data-js-product-item]');
					if ( ! card ) return;
					grid.appendChild(document.importNode(card, true));
					added++;
				});
				if ( ! added ) return;
				this.style.display = '';
				this.fixHeight(grid);
				window.addEventListener('resize', () => this.fixHeight(grid));
			});

		}

		fixHeight(grid) {
			const heading = this.querySelector('.box__heading');
			if ( ! heading ) return;
			const desktop = window.matchMedia('(min-width: 1025px), (min-width: 769px) and (orientation: landscape)').matches;
			if ( desktop ) heading.style.setProperty('height', (grid.offsetHeight - 1) + 'px', 'important');
			else heading.style.removeProperty('height');
		}

	}

	customElements.define('recently-viewed', RecentlyViewed);

}
